$(function(){
  var auto_add_card_variant_ids = [
    32368500080737,
    32368486940769,
    32368469344353,
    32368469344353,
    32368481992801,
  ]

  var card_variant_id = 32502293200993;

  var _cartHasEligibleMask = function(cart) {
    return cart
      .items
      .filter(function(item) {
        return auto_add_card_variant_ids.includes(item.id)
      })
      .length > 0
  }

  var _cartHasCard = function(cart) {
    return cart
      .items
      .filter(function(item) {
        return item.id === card_variant_id
      })
      .length > 0
  }

  document.addEventListener('product:added', function(event) {
    var variant = event.detail.variant; // Get the variant that was added
    var quantity = event.detail.quantity; // Get the quantity that was added
    var variant_id = variant.id;
    if (! auto_add_card_variant_ids.includes(variant_id)) {
      return false;
    }

    $.getJSON('/cart.json')
      .then(function(cart){
        if (_cartHasCard(cart)) {
          throw 'Already has card'
        }
        return cart
      })
      .then(function(cart) {
        console.log("adding mask", {
          id: card_variant_id,
          quantity: 1
        })
        $.post('/cart/add.js', {
          id: card_variant_id,
          quantity: 1
        })
      })
      .catch(function(error){
        console.error(error)
      })
  });

  document.addEventListener('cart:updated', function(event) {
    let cart = event.detail.cart;

    if (! _cartHasEligibleMask(cart) && _cartHasCard(cart)) {
      console.log("removing card")
      $.post('/cart/change.js', {
        id: card_variant_id,
        quantity: 0
      }).then(function() {
        setTimeout(function(){
          $('.Cart__ItemList').find(`.CartItem a[href*=${card_variant_id}]`).closest('.CartItemWrapper').remove()
        }, 2000)
      })
    }
    
  });

})